<template>
  <div style="width: 100%;color: #1F75D5; text-indent:20px">
    <span>{{ params.displayName }}</span>
    <i class="el-icon-question" :title="$t('SeaExport.SeaguardianSupportsSM2WeighingMethod')" />
  </div>
</template>

<script>

import Vue from 'vue'
export default Vue.extend({
  name: 'VgmWeighingMethodHeader'
})
</script>

<style scoped>

</style>
